import { FormattedMessage } from 'react-intl';
import { FormErrors, PageLoading, useDataProvider } from '@ui-framework/index';
import { Box } from '@mui/material';
import React, {
  createContext,
  useContext,
  useMemo,
  useEffect,
  useState,
} from 'react';

const ServiceJobContext = createContext({});

export function ServiceJobProvider({ serviceJobId, children }) {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState(null);
  const [serviceJob, setServiceJob] = useState(null);

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const getServiceJob = async () => {
    const serviceJobuUrl = `${getApiUrl()}/sxcl/v1/service-jobs/${serviceJobId}`;
    const response = await get(serviceJobuUrl);
    return response;
  };

  const initialize = async () => {
    setLoading(true);
    setErrors(null);
    let serviceJobFound = null;
    let errorsFound = [];
    try {
      const serviceJobResponse = await getServiceJob();
      if (serviceJobResponse?.ok) {
        serviceJobFound = serviceJobResponse?.data;
      } else {
        errorsFound = [...errorsFound, ...serviceJobResponse.errors];
      }
    } catch (err) {
      errorsFound = [{ message: err.message }];
    }

    setServiceJob(serviceJobFound);
    setErrors(errorsFound);
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  const value = useMemo(() => ({ serviceJob }), [serviceJob]);

  if (loading) {
    return (
      <PageLoading>
        <FormattedMessage
          id="LOADING_SERVICE_JOB"
          defaultMessage="Loading Service Job"
        />
        ...
      </PageLoading>
    );
  }

  return (
    <ServiceJobContext.Provider value={value}>
      {Array(errors) && errors.length > 0 ? (
        <FormErrors errors={errors} />
      ) : (
        <Box>{children}</Box>
      )}
    </ServiceJobContext.Provider>
  );
}

export const useServiceJob = () => {
  return useContext(ServiceJobContext);
};
